import { ComponentProps } from "@models/types";
import { ToolbarButton } from "./ToolbarButton";

// Custom Undo icon component from Quill editor. You can import it directly
// from 'quill/assets/icons/undo.svg' but I found that a number of loaders do not
// handle them correctly.
export const UndoIcon = () => (
    <svg viewBox="0 0 18 18">
        <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
        <path
            className="ql-stroke"
            d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
        />
    </svg>
);

export type UndoButtonProps = ComponentProps & {
    tooltip?: string
};

export const UndoButton = ({tooltip, className, style, children}: UndoButtonProps) => {
    return (
        <ToolbarButton className={className} style={style} module="undo" tooltip={tooltip || "Undo"}><UndoIcon />
            {children}
        </ToolbarButton>
    );
};

export default UndoButton;